import {
	useDisclosure,
	AlertDialog as ChakraAlertDialog,
	AlertDialogBody,
	AlertDialogCloseButton,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogOverlay,
	Button,
} from '@chakra-ui/react';
import React from 'react';

export function useAlertDialog() {
	const {
		isOpen, onOpen: openDialog, onClose: closeDialog, 
	} = useDisclosure();

	return {
		isOpen,
		openDialog,
		closeDialog,
		AlertDialog,
	};
}

export const AlertDialog = ({
	isOpen, openDialog, closeDialog, submitDialog, title, description
}) => {
	const cancelRef = React.useRef();

	return (
		<>
			<ChakraAlertDialog
				motionPreset="slideInBottom"
				leastDestructiveRef={cancelRef}
				onClose={closeDialog}
				isOpen={isOpen}
				isCentered
			>
				<AlertDialogOverlay />

				<AlertDialogContent>
					<AlertDialogHeader>{title}</AlertDialogHeader>
					<AlertDialogCloseButton />
					<AlertDialogBody>{description}</AlertDialogBody>
					<AlertDialogFooter>
						<Button
							ref={cancelRef}
							onClick={closeDialog}
						>No</Button>
						<Button
							onClick={submitDialog}
							colorScheme="red"
							ml={3}
						>Yes</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</ChakraAlertDialog>
		</>
	);
};
